// extracted by mini-css-extract-plugin
module.exports = {"box":"DataBox_box__2zbWq","countrysBox":"DataBox_countrysBox__1uliC","text":"DataBox_text__1PBAv"};